import styles from "styles/pages/reports/reports.module.scss";

import { Button, Checkbox, Drawer, Label } from "@components";
import { useEffect, useState } from "react";
import { If } from "shared/components/control-statements";

import classNames from "classnames/bind";
import TimeFilter from "pages/Reports/TimeFilter";
const css = classNames.bind(styles);

const creativeTypes = {
  EmailCreativeAction: {
    key: "EmailCreativeAction",
    name: "E-mail",
  },
  PushCreativeAction: {
    key: "PushCreativeAction",
    name: "Push",
  },
  SmsCreativeAction: {
    key: "SmsCreativeAction",
    name: "SMS",
  },
  WhatsAppCreativeAction: {
    key: "WhatsAppCreativeAction",
    name: "WhatsApp",
  },
};

const FilterColumns = ({
  propFilters,
  visible,
  onClose,
  onApplyFilters,
  withoutTransition,
}) => {
  const [selectedOptionFilter, setSelectedOptionFilter] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState({
    DRAFT: true,
    PAUSED: true,
    ARCHIVED: false,
    PUBLISHED: true,
  });
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [createdDate, setCreatedDate] = useState(null);
  const [createdDateFilterType, setCreatedDateFilterType] = useState(null);
  const [lastSendDate, setLastSendDate] = useState(null);
  const [lastSendDateFilterType, setLastSendDateFilterType] = useState(null);
  const [filters, setFilters] = useState({});

  // useEffect(() => {
  //   setFilters(propFilters);
  // }, [propFilters])

  useEffect(() => {
    if (visible) setSelectedOptionFilter(null);
  }, [visible]);

  const getTitle = () => {
    switch (selectedOptionFilter) {
      case "Status":
        return "Status";
      case "Data de criação":
        return "Data de criação";
      case "Último disparo":
        return "Último disparo";
      case "Canal":
        return "Canal";
      default:
        return "Filtrar colunas";
    }
  };

  const formatFilterParams = () => {
    const payload = {};

    const createdDate = filters.createdDate || null;
    const lastSendDate = filters.lastSendDate || null;

    payload.status = selectedStatus;
    if (selectedChannels.length) payload.channels = selectedChannels;

    if (createdDate?.begin || createdDate?.end || createdDateFilterType) {
      payload.createdDate = {
        ...(createdDate?.begin && { start_date: createdDate.begin }),
        ...(createdDate?.end && { end_date: createdDate.end }),
        ...(createdDateFilterType && { period: createdDateFilterType }),
      };
    }

    if (lastSendDate?.begin || lastSendDate?.end || lastSendDateFilterType) {
      payload.lastSendDate = {
        ...(lastSendDate?.begin && { start_date: lastSendDate.begin }),
        ...(lastSendDate?.end && { end_date: lastSendDate.end }),
        ...(lastSendDateFilterType && { period: lastSendDateFilterType }),
      };
    }

    return payload;
  };

  const onChangeFilters = (dateFilters) => {
    const newFilterParams = { ...filters };

    for (const [key, value] of Object.entries(dateFilters)) {
      newFilterParams[key] = value;
    }

    setFilters({ ...newFilterParams });
  };

  const applyFilters = () => {
    const newFilters = formatFilterParams();
    // console.log("newFilters", newFilters);
    onApplyFilters(newFilters);
  };

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      title={getTitle()}
      showBackButton={true}
      backButton={() => onClose()}
      withoutTransition={withoutTransition}
    >
      <div className={styles.filterColumnsContainer}>
        <If cond={!selectedOptionFilter}>
          <Label>O que deseja filtrar?</Label>

          <div className={styles.optionsFilterColumns}>
            {["Status", "Data de criação", "Último disparo", "Canal"].map(
              (option) => (
                <div
                  className={styles.option}
                  onClick={() => setSelectedOptionFilter(option)}
                >
                  <p>{option}</p>
                  <div className="d-flex align-center">
                    <span className={styles.divider} />
                    <i className="far fa-chevron-right" />
                  </div>
                </div>
              )
            )}
          </div>
        </If>

        <If cond={selectedOptionFilter === "Status"}>
          <Label>Selecione quais status deseja exibir</Label>

          <div className={styles.items}>
            {[
              { name: "Rascunho", value: "DRAFT" },
              { name: "Publicado", value: "PUBLISHED" },
              { name: "Pausado ", value: "PAUSED" },
              { name: "Arquivado", value: "ARCHIVED" },
            ].map((item) => (
              <div
                className={css({
                  item: true,
                  disabled: !selectedStatus[item.value],
                })}
                onClick={() =>
                  setSelectedStatus({
                    ...selectedStatus,
                    [item.value]: !selectedStatus[item.value],
                  })
                }
              >
                <Checkbox checked={selectedStatus[item.value]} readOnly />
                <div className="d-flex align-center">
                  <span className={styles.divider} />
                  <p className={styles.name}>{item.name}</p>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.filtersColumnsFooter}>
            <Button
              className="w-100"
              design="primary"
              onClick={() => {
                applyFilters(filters);
                setSelectedOptionFilter(null);
              }}
            >
              Aplicar
            </Button>
          </div>
        </If>

        <If cond={selectedOptionFilter === "Canal"}>
          <Label>Selecione quais canais deseja exibir</Label>

          <div className={styles.items}>
            {[
              {
                name: creativeTypes.SmsCreativeAction.name,
                key: creativeTypes.SmsCreativeAction.key,
              },
              {
                name: creativeTypes.EmailCreativeAction.name,
                key: creativeTypes.EmailCreativeAction.key,
              },
              {
                name: creativeTypes.PushCreativeAction.name,
                key: creativeTypes.PushCreativeAction.key,
              },
              {
                name: creativeTypes.WhatsAppCreativeAction.name,
                key: creativeTypes.WhatsAppCreativeAction.key,
              },
            ].map((item) => (
              <div
                className={css({
                  item: true,
                  disabled: selectedChannels.includes(item.key),
                })}
                onClick={() =>
                  setSelectedChannels((prev) =>
                    prev.includes(item.key)
                      ? prev.filter((c) => c !== item.key)
                      : [...prev, item.key]
                  )
                }
              >
                <Checkbox
                  checked={!selectedChannels.includes(item.key)}
                  readOnly
                />
                <div className="d-flex align-center">
                  <span className={styles.divider} />
                  <p className={styles.name}>{item.name}</p>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.filtersColumnsFooter}>
            <Button
              className="w-100"
              design="primary"
              onClick={() => {
                applyFilters({ ...filters, channel: selectedChannels });
                setSelectedOptionFilter(null);
              }}
            >
              Aplicar
            </Button>
          </div>
        </If>

        <If cond={selectedOptionFilter === "Data de criação"}>
          <TimeFilter
            onUpdateFilters={(dateFilters) => {
              onChangeFilters({ createdDate: dateFilters });
            }}
            onUpdateFilterValues={(values, selectedFilterType) => {
              setCreatedDateFilterType(selectedFilterType);
              setCreatedDate(values);
            }}
            values={createdDate}
            filterType={createdDateFilterType}
          />

          <div className={styles.filtersColumnsFooter}>
            <Button
              className="w-100"
              design="primary"
              onClick={() => {
                applyFilters({ ...filters, createdDate: createdDate });
                setSelectedOptionFilter(null);
              }}
            >
              Aplicar
            </Button>
          </div>
        </If>

        <If cond={selectedOptionFilter === "Último disparo"}>
          <TimeFilter
            onUpdateFilters={(dateFilters) => {
              onChangeFilters({ lastSendDate: dateFilters });
            }}
            onUpdateFilterValues={(values, selectedFilterType) => {
              setLastSendDateFilterType(selectedFilterType);
              setLastSendDate(values);
            }}
            values={lastSendDate}
            filterType={lastSendDateFilterType}
          />

          <div className={styles.filtersColumnsFooter}>
            <Button
              className="w-100"
              design="primary"
              onClick={() => {
                applyFilters({ ...filters, lastSendDate: lastSendDate });
                setSelectedOptionFilter(null);
              }}
            >
              Aplicar
            </Button>
          </div>
        </If>
      </div>
    </Drawer>
  );
};

export default FilterColumns;
